export default "__VITE_ASSET__86LNjOQh__"